const textFields = ["str", "prefix", "mcc_mnc"];

// Delay typing only. Clearing or choosing a filter also cancels pending typing.
export const getFilterChangeDelay = (next, previous) => {
    const changedKeys = [...new Set([...Object.keys(previous), ...Object.keys(next)])]
        .filter(key => next[key] !== previous[key]);

    return changedKeys.length && changedKeys.every(key =>
        textFields.includes(key) && typeof next[key] === "string" && next[key].length > 0
    ) ? 500 : 0;
};
